/**
 * Project details API: edit a project's name, description, client, dates and
 * place. The money routes (contract value, pipeline stage) stay separate and
 * are not part of this.
 *
 * The URL is `/planning/workspaces/:project_id`, not `planningPath()`: the
 * project being edited is named by the caller (a card on the Projects page can
 * be any project in the account), not by the active project.
 */
import { apiPut } from './PlanningApiClient';
import { apiId } from '../utils/apiId';

export interface ProjectDetails {
  project_id: string;
  /** Older servers only send this spelling. */
  wedding_id?: string;
  workspace_id?: string | null;
  name: string;
  description: string | null;
  client_id: string | null;
  client_name: string | null;
  date_start: string | null;
  date_end: string | null;
  event_date: string | null;
  location_city: string | null;
  location_country: string | null;
}

/** Any subset of these may be sent; `null` clears an optional field. */
export interface ProjectUpdate {
  name?: string;
  description?: string | null;
  client_id?: string | null;
  date_start?: string | null;
  date_end?: string | null;
  event_date?: string | null;
  location_city?: string | null;
  location_country?: string | null;
}

export async function updateProject(projectId: string, updates: ProjectUpdate): Promise<ProjectDetails> {
  const id = apiId(projectId);
  if (!id) throw new Error('This project has not been saved yet.');
  const res = await apiPut<ProjectDetails | { success?: boolean; data: ProjectDetails }>(`/planning/workspaces/${id}`, updates);
  return 'data' in res && res.data ? res.data : (res as ProjectDetails);
}
